import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { MappedVehicleType } from '../../types';
import useApiCall from '../../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import VehiclesService from '../../../../../services/affreightment/VehiclesService';

interface UseDeleteVehicleInterface {
  loadVehicles: () => void;
}

export default function useDeleteVehicle({ loadVehicles }: UseDeleteVehicleInterface) {
  const [vehicleBeingDeleted, setVehicleBeingDeleted] = useState<MappedVehicleType>({} as MappedVehicleType);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const { apiCall } = useApiCall();
  const {
    userName,
    userProfile,
    userCode,
    companyCode,
  } = useGetGeneralAppData();

  const deleteVehicle = useCallback(async () => {
    await apiCall({
      apiToCall: VehiclesService.deleteVehicle,
      queryParams: {
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codVeiculoSis: vehicleBeingDeleted.vehicleId,
        codEmpresa: companyCode,
      },
      onStartLoad: () => setIsDeleting(true),
      onEndLoad: () => setIsDeleting(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível remover o veículo. Por favor, tente novamente. (${response.msg})`);
          return;
        }
        toast.success('O veículo foi removido com sucesso');
        setDeleteModalShow(false);
        loadVehicles();
      },
      catchMessage: 'Não foi possível remover o veículo. Por favor, tente novamente',
    });
  }, [apiCall, companyCode, loadVehicles, userCode, userName, userProfile, vehicleBeingDeleted.vehicleId]);

  function handleOpenDeleteVehicleModal(vehicle: MappedVehicleType) {
    setVehicleBeingDeleted(vehicle);
    setDeleteModalShow(true);
  }

  return {
    vehicleBeingDeleted,
    deleteModalShow,
    setDeleteModalShow,
    isDeleting,
    deleteVehicle,
    handleOpenDeleteVehicleModal,
  };
}
